import styled from "styled-components";

export const DashboardTitle = styled.article`
  font-size: 24px;
  text-align: center;
  font-weight: bold;
`;

export const colours = {
  yomento_purple: "#6001D9",
  yomento_grey: "#949494",
};
